import moment from 'moment';
import React from 'react';

const DATE_FORMAT_WITHOUT_YEAR = 'MMM DD';
const DATE_FORMAT_WITH_YEAR = 'MMM DD, YYYY';

interface Props {
  start: string;
  end: string;
}

const FormattedDateRange = ({ start, end }: Props) => {
  const startDate = moment.utc(start);
  const endDate = moment.utc(end);

  const isRangeInSameYear = startDate.year() === endDate.year();

  const formattedStartDate = isRangeInSameYear
    ? startDate.format(DATE_FORMAT_WITHOUT_YEAR)
    : startDate.format(DATE_FORMAT_WITH_YEAR);

  const formattedEndDate = endDate.format(DATE_FORMAT_WITH_YEAR);

  return (
    <span>
      {formattedStartDate} - {formattedEndDate}
    </span>
  );
};

export default FormattedDateRange;
